var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h2',[_vm._v(_vm._s(_vm.h2))]),(_vm.h3 !== '')?_c('h3',[_vm._v(": "+_vm._s(_vm.h3))]):_vm._e(),_c('img',{attrs:{"src":require("@/assets/icons/icon-scrolldown.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }